/* eslint-disable import/prefer-default-export */
import getCookie from "helpers/getCookie";
import { GeoData } from "services/searchSuggestionsService";
import getUserCountry from "@Pages/Search/components/SearchList/components/TrustPilotBanner/helper";

/**
 * Extracts geo-data for personalized search suggestions.
 * Reads country and city from localStorage/cookie (populated by fetchCountryData).
 * Falls back to getUserCountry() API call if no cached data is available.
 */
export const getGeoDataForSearchSuggestions = async (): Promise<GeoData> => {
  let sourceCountry: string | null = null;
  let sourceCity: string | null = null;

  if (typeof window !== "undefined") {
    sourceCountry = localStorage.getItem("country");
    sourceCity = localStorage.getItem("city");
  }

  // Fallback country to cookie
  if (!sourceCountry) {
    const cookieCountry = getCookie("userCountry");
    if (cookieCountry) {
      sourceCountry = cookieCountry;
    }
  }

  // If still no country, fetch it (getUserCountry handles deduplication internally)
  if (!sourceCountry && typeof window !== "undefined") {
    try {
      const data = await getUserCountry();
      if (data?.country) {
        sourceCountry = data.country;
      }
      if (data?.city) {
        sourceCity = data.city;
      }
    } catch {
      // Silently fail — personalized search will fallback to static
    }
  }

  return {
    sourceCountry: sourceCountry || null,
    sourceCity: sourceCity || null,
  };
};
